import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { UserInfoAvatar } from 'features/user_profiles';
import { Email, TextWrapper, Title, Wrapper } from './shared';
import { FullStoryExclude, FullStoryMask } from '../../shared/fullstory_privacy';
const badgeWrapperCss = "b1hiwiwr";
const BadgeWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(badgeWrapperCss, props.className)} />;
});
const isMigrating = invitation => invitation.status === 'migrating' || invitation.target_organization_uuid;
const invitationTitle = invitation => {
  if (isMigrating(invitation)) {
    return <Title>
        {invitation.name}
        <BadgeWrapper>
          <Badge spacingLeft="8">
            {I18n.t('publisher.organization.memberships_picker.pending_migration')}
          </Badge>
        </BadgeWrapper>
      </Title>;
  }
  if (invitation.status !== 'migrating') {
    return <Title>
        <BadgeWrapper>
          <Badge>{I18n.t('publisher.organization.memberships_picker.pending_invitation')}</Badge>
        </BadgeWrapper>
      </Title>;
  }
  return null;
};
export const InvitationInfo = ({
  invitation,
  isAvatarNonInteractive = false
}) => <Wrapper>
    <FullStoryExclude>
      <UserInfoAvatar letter={invitation.avatar_letter} uuid={invitation.organization_invitation_uuid} name={invitation.name} isNonInteractive={isAvatarNonInteractive} isPendingUser />
    </FullStoryExclude>
    <TextWrapper>
      {invitationTitle(invitation)}
      <Email><FullStoryMask>{invitation.email}</FullStoryMask></Email>
    </TextWrapper>
  </Wrapper>;

require("./invitation_info.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./invitation_info.js");